// extracted by mini-css-extract-plugin
module.exports = {"weekly__planner":"styles_weekly__planner__13CeJ","weekly__planner--text":"styles_weekly__planner--text__1wBp3","weekly__planner--img":"styles_weekly__planner--img__1irp-"};